import { v4 } from 'uuid';

import { PanelTrimType } from './enums';
import { RecordData } from '../../helpers-classes';
import { PanelTrimData, PanelTrimDataIn, PanelTrimPanels } from './types';

export const panelTrimData = (dataIn: PanelTrimDataIn = null): PanelTrimData => {
	const rd = new RecordData<PanelTrimDataIn>(dataIn);

	const record: PanelTrimData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		trimType: rd.useNewOrDefault<PanelTrimType>('trimType', null),
		panels: rd.useNewOrDefault<PanelTrimPanels>('panels', [])
	}

	return record;
};
